import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { apiResponseFormat } from '@app/common/variables';
import { Configuration } from '@app/common/configuration';
import { environment } from '../../../environments/environment';
import { RoleDto } from '@app/apiModules/roleDtoPagedResultDto';
import { UserDto } from '@app/apiModules/userDto';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = 'api/users'; // Replace with your actual API endpoint
  public encoder: HttpParameterCodec;
  authServerUrl = environment.API_APP_PATH;
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  constructor(protected httpClient: HttpClient) { }

   /**
   * @param tenantId 
   * @param userId 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiAppUserUserRolesGet(userId?: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<Array<RoleDto>>;
  public apiAppUserUserRolesGet(userId?: string, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpResponse<Array<RoleDto>>>;
  public apiAppUserUserRolesGet(userId?: string, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpEvent<Array<RoleDto>>>;
  public apiAppUserUserRolesGet(userId?: string, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<any> {

    let queryParameters = new HttpParams({ encoder: this.encoder });
    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'text/plain',
        'application/json',
        'text/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }
      headers = headers.set('__eventId', "");
    if (userId !== undefined && userId !== null) {
      headers = headers.set('__subId', userId);
    }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<RoleDto>>(`${this.authServerUrl}/api/app/user/userRoleDetails`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
        
    }

    /*
     * 
     * @param httpParams
     * @param value
     * @param key
     * @returns
     */
    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                httpParams = this.getHttpParamsFromObject(httpParams, value, key);
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Cancel logout on browser refresh - Insert/Update user session
     * @param browserSessionId - The browser session ID
     * @param accessToken - The access token to update
     * @param observe - Set whether or not to return the data Observable as the body, response or events
     * @param reportProgress - Flag to report request and response progress
     */
    public apicancelLogoutOnBrowserRefreshPost(browserSessionId?: string, accessToken?: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<boolean>;
    public apicancelLogoutOnBrowserRefreshPost(browserSessionId?: string, accessToken?: string, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpResponse<boolean>>;
    public apicancelLogoutOnBrowserRefreshPost(browserSessionId?: string, accessToken?: string, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpEvent<boolean>>;
    public apicancelLogoutOnBrowserRefreshPost(browserSessionId?: string, accessToken?: string, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        const formData = new FormData();
        if (accessToken) {
            formData.append('tokenParam', accessToken);
        }

        return this.httpClient.post<boolean>(
            `${this.authServerUrl}/api/app/release-mgmt/cancel-logout-on-browser-refresh/${encodeURIComponent(browserSessionId)}`,
            formData,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    
    /*
     * 
     * @param httpParams
     * @param value
     * @param key
     * @returns
     */
    private getHttpParamsFromObject(httpParams: HttpParams, value?: any, key?: string){
        Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        return httpParams;
    }

    /*
     * 
     * @param httpParams
     * @param value
     * @param key
     * @returns
     */
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    public apiAppUserADUsersGet(keyword?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept: undefined}): Observable<any>;
    public apiAppUserADUsersGet(keyword?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept: undefined}): Observable<HttpResponse<any>>;
    public apiAppUserADUsersGet(keyword?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept: undefined}): Observable<HttpEvent<any>>;
    public apiAppUserADUsersGet(keyword?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept: undefined}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (keyword !== undefined && keyword !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>keyword, 'keyword');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<any>(`${this.authServerUrl}/api/app/user/a-dUsers`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public apiAppUserADUsersPost(UserDto?: UserDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<string>;
    public apiAppUserADUsersPost(UserDto?: UserDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<HttpResponse<string>>;
    public apiAppUserADUsersPost(UserDto?: UserDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<HttpEvent<string>>;
    public apiAppUserADUsersPost(UserDto?: UserDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<string>(`${this.authServerUrl}/api/app/user/user`,
            UserDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public apiAppUpdateUsersPost(UserDto?: UserDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<string>;
    public apiAppUpdateUsersPost(UserDto?: UserDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<HttpResponse<string>>;
    public apiAppUpdateUsersPost(UserDto?: UserDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<HttpEvent<string>>;
    public apiAppUpdateUsersPost(UserDto?: UserDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<string>(`${this.authServerUrl}/api/app/user/update-user`,
            UserDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public apiAppUserUserApprovalPost(userTenantDto?: any, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept: undefined}): Observable<any>;
    public apiAppUserUserApprovalPost(userTenantDto?: any, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept: undefined}): Observable<HttpResponse<any>>;
    public apiAppUserUserApprovalPost(userTenantDto?: any, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept: undefined}): Observable<HttpEvent<any>>;
    public apiAppUserUserApprovalPost(userTenantDto?: any, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept: undefined}): Observable<any> {

        let headers = this.defaultHeaders; 

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<any>(`${this.authServerUrl}/api/app/user/userApproval`,
            userTenantDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
        public apiAppUserUserManagementPaginationPost( sorting?: string, skipCount?: number, maxResultCount?: number, searchKeyword?: string, searchFilterInfo?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<UserDtoPagedResultDto>;//NOSONAR
    public apiAppUserUserManagementPaginationPost( sorting?: string, skipCount?: number, maxResultCount?: number, searchKeyword?: string, searchFilterInfo?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<HttpResponse<UserDtoPagedResultDto>>;//NOSONAR
    public apiAppUserUserManagementPaginationPost( sorting?: string, skipCount?: number, maxResultCount?: number, searchKeyword?: string, searchFilterInfo?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<HttpEvent<UserDtoPagedResultDto>>;//NOSONAR
    public apiAppUserUserManagementPaginationPost( sorting?: string, skipCount?: number, maxResultCount?: number, searchKeyword?: string, searchFilterInfo?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<any> {//NOSONAR

        /**
         * User management dto
         */
        let userManagementDto = {
            "input": {
              "maxResultCount": maxResultCount,
              "skipCount": skipCount,
              "sorting": sorting
            },
            "searchKeyword": searchKeyword,
            "searchFilterInfo": searchFilterInfo
          };
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
            
        }
        
        {headers = headers.set('__eventId', "");}

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.post<UserDtoPagedResultDto>(`${this.authServerUrl}/api/app/user/get-users`,
            userManagementDto,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public apiAppUserbyUserIdGet(userId: string,azureAccountDetails?:any, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<UserDto>;
    public apiAppUserbyUserIdGet(userId: string,azureAccountDetails?:any, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<HttpResponse<UserDto>>;
    public apiAppUserbyUserIdGet(userId: string,azureAccountDetails?:any, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<HttpEvent<UserDto>>;
    public apiAppUserbyUserIdGet(userId: string,azureAccountDetails?:any, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: apiResponseFormat}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling .');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
       

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get<UserDto>(`${this.authServerUrl}/api/app/user/id/${(String(userId))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public apiAppUserIdSetActiveInactivePost(id: string, status?: boolean, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<UserDto>;
    public apiAppUserIdSetActiveInactivePost(id: string, status?: boolean, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpResponse<UserDto>>;
    public apiAppUserIdSetActiveInactivePost(id: string, status?: boolean, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpEvent<UserDto>>;
    public apiAppUserIdSetActiveInactivePost(id: string, status?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAppUserIdSetActiveInactivePost.');
        }

        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (status !== undefined && status !== null) {
            queryParameters = this.addToHttpParams(queryParameters,
                <any>status, 'status');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.post<UserDto>(`${this.authServerUrl}/api/app/user/${(String(id))}/set-active-inactive-user`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public apiAppUserIdDelete(id: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<any>;
    public apiAppUserIdDelete(id: string, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<HttpResponse<any>>;
    public apiAppUserIdDelete(id: string, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<HttpEvent<any>>;
    public apiAppUserIdDelete(id: string, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept: undefined }): Observable<any> {
       if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAppUserIdDelete.');
        }

        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (status !== undefined && status !== null) {
            queryParameters = this.addToHttpParams(queryParameters,
                <any>status, 'status');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


         let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.post<string>(`${this.authServerUrl}/api/app/user/${(String(id))}/delete`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}


interface UserDtoPagedResultDto {
  totalCount?: number;
  items?: Array<UserDto> | null;
}

export interface Tile {
  id: string,
  imgTitle: string,
  title: string,
  subTitle: string,
  statusText: string,
  subStatusText: string,
  tenantid: string,
  concurrencyStamp: string,
  status: any,
  isDeactivated?: boolean,
  extraProperties: any[],
  image: string,
  lastLoginDate?: string,
  updatedOnOrg?: string,
  isForTenant?: boolean,
  tenantTileStatus?: string,
  tileButtonColor?: string,
  tileButtontranslationKey?: string,
}


export const TILES = [
  { imgTitle: 'DB', title: 'Deutch Bank', subTitle: 'German Bank tenant', statusText: '24 Jun 2020', subStatusText: '1contact@deutchbank.com' },
  { imgTitle: 'SA', title: 'Santander', subTitle: 'Largest Spain bank', statusText: '15 Jun 2020', subStatusText: '2contact@santander.com' },
  { imgTitle: 'CB', title: 'Chase Bank', subTitle: 'US branch of JP Morgan bank', statusText: '10 Jun 2010', subStatusText: '3contact@chase.com' },
  { imgTitle: 'CC', title: 'Coca Cola', subTitle: 'Atlanta coke branch', statusText: '30 Jun 2020', subStatusText: '4contact@coke.com' },
  { imgTitle: 'ST', title: 'Starbucks', subTitle: 'Large coffe shop in US', statusText: '2 Jun 2020', subStatusText: '5contact@starbucks.com' },
  { imgTitle: 'DB', title: 'Deutch Bank', subTitle: 'German Bank tenant', statusText: '24 Jun 2020', subStatusText: '6contact@deutchbank.com' },
  { imgTitle: 'SA', title: 'Santander', subTitle: 'Largest Spain bank', statusText: '15 Jun 2020', subStatusText: '7contact@santander.com' },
  { imgTitle: 'CB', title: 'Chase Bank', subTitle: 'US branch of JP Morgan bank', statusText: '10 Jun 2010', subStatusText: '8contact@chase.com' },
  { imgTitle: 'CC', title: 'Coca Cola', subTitle: 'Atlanta coke branch', statusText: '30 Jun 2020', subStatusText: '9contact@coke.com' },
  { imgTitle: 'ST', title: 'Starbucks', subTitle: 'Large coffe shop in US', statusText: '2 Jun 2020', subStatusText: '10contact@starbucks.com' },
  { imgTitle: 'DB', title: 'Deutch Bank', subTitle: 'German Bank tenant', statusText: '24 Jun 2020', subStatusText: '11contact@deutchbank.com' },
  { imgTitle: 'SA', title: 'Santander', subTitle: 'Largest Spain bank', statusText: '15 Jun 2020', subStatusText: '12contact@santander.com' },
  { imgTitle: 'CB', title: 'Chase Bank', subTitle: 'US branch of JP Morgan bank', statusText: '10 Jun 2010', subStatusText: '13contact@chase.com' },
  { imgTitle: 'CC', title: 'Coca Cola', subTitle: 'Atlanta coke branch', statusText: '30 Jun 2020', subStatusText: '14contact@coke.com' },
  { imgTitle: 'ST', title: 'Starbucks', subTitle: 'Large coffe shop in US', statusText: '2 Jun 2020', subStatusText: '15contact@starbucks.com' }
];

export interface IdentityUserDto {
  tenantId?: string | null;
  userName?: string | null;
  name?: string | null;
  surname?: string | null;
  email?: string | null;
  emailConfirmed?: boolean;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  lockoutEnabled?: boolean;
  lockoutEnd?: string | null;
  concurrencyStamp?: string | null;
  isDeleted?: boolean;
  deleterId?: string | null;
  deletionTime?: string | null;
  lastModificationTime?: string | null;
  lastModifierId?: string | null;
  creationTime?: string;
  creatorId?: string | null;
  id?: string;
  preferredUserLanguage?: string | null;
}


// export interface UserDto {
//   id?: string;
//   userName?: string | null;
//   name?: string | null;
//   surname?: string | null;
//   fullname?: string | null;
//   email?: string | null;
//   emailConfirmed?: boolean;
//   emailList?: Array<object> | null;
//   phoneNumber?: string | null;
//   phoneNumberConfirmed?: boolean;
//   status?: string | null;
//   roleNames?: Array<string> | null;
//   password?: string | null;
//   concurrencyStamp?: string | null;
//   tenantNames?: Array<string> | null;
//   selectedRoleIds?: Array<string> | null;
//   authMode?: string | null;
//   createdOn?: string;
//   updatedOn?: string | null;
//   profilePic?: string | null;
//   displayName?: string | null;
//   language?: string | null;
//   browserSessionId?: string | null;
//   preferredUserLanguage?: string | null;
//   // Comma separated role names
//   displayRoleNames?: string | null;
//   preferredUserLanguageCode?: string | null;
//   preferredUserISOLanguageCode?: string | null;
//   // Language support enabled flag
//   isLanguageSupportEnabled?: boolean | null;
//   baseLanguageCode?: string | null;
//   // Sharepoint enabled flag
//   isSharePointEnabled?: boolean | null;
//   // Sharepoint creation allowed flag
//   isSharePtCreationAllowed?: boolean | null;
// }

